import React from 'react';
import Text from '../Shared/Text';

const concurrentProjectsFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <Text
      key={pkg.code}
      text={
        pkg?.maxProjects > 0 ? pkg.maxProjects : 'concurrentProjectsUnlimited'
      }
    />
  ));

export default concurrentProjectsFeatures;
